import Param from "../../../param";
import Util from "../../libs/util";
import Force from "../util/force";
import MakeVideo from '../util/makeVideo';
import MakeTexture from '../util/makeTexture';


const param = new Param();
const util = new Util();

let force = new Force();
/* --------------------------------------------
*
*  -- [ 背景動画 or イメージの読み込み ]
*
* -------------------------------------------- */

export default class MainvisualBg {
    constructor(w,h){

        this.w = w;
        this.h = h;

        this.video=[];
        this.videoMesh=[];
        this.texture = [];
        this.textureMesh;

        this.type;/* texture or video */

        this.conf = {
            // speed : 1.6,
            speed : 0.3,
            // ease  : Back.easeIn.config(1)
            ease: SlowMo.ease.config(0.4, 0.8, false),
        }

        this.status = {
            video : {
                play : []
            }
        }

        this.save = { /* 一時的に保持するもの */
            scale : {
                show : [],
                out  : []
            },
            positionY : {
                show : [],
                out  : []
            },
        }




    }
    init(scene,type,no){

        let _this = this;

        if(type=="video"){
            this.status.video.play[no] = false;
            this.video[no] = new MakeVideo(param.webgl.mainvisual.scene[no].src,param.webgl.mainvisual.scene[no].thum);
            _this.videoMesh[no] = _this.video[no].init();

            // console.log(_this.videoMesh[no].videoThumTexture);
            scene.add(_this.videoMesh[no]);
            _this.resize(_this.w,_this.h)

            if(!Useragnt.ie)_this.video[no].video.video.addEventListener('canplay', (e) => {
                // console.log("load video")
                if(this.status.video.play[no]) return;
                this.status.video.play[no] = true;
                _this.video[no].uniforms.texture.value = _this.video[no].videoTexture;
                _this.video[no].video.video.play();
                _this.resize(_this.w,_this.h)
                // alert("loaded")
                // $("#p-kv-content").on("click",()=>{
                //     alert("click")
                //     console.log("click")
                //     this.video[0].video.video.play();
                // })

            } , false);

            // _this.video[no].video.video.addEventListener('load', (e) => {
            //     alert("load");
            // } , false);
            // _this.video[no].video.video.addEventListener('waiting', (e) => {
            //     alert("waiting");
            // } , false);
            // _this.video[no].video.video.addEventListener('loadedmetadata', (e) => {
            //     alert("loadedmetadata");
            // } , false);
            // _this.video[no].video.video.addEventListener('loadeddata', (e) => {
            //     alert("loadeddata");
            // } , false);
            // _this.video[no].video.video.addEventListener('canplaythrough', (e) => {
            //     alert("canplaythrough");
            // } , false);
            // _this.video[no].video.video.addEventListener('canplay', (e) => {
            //     alert("canplay");
            // } , false);


        }else{
            this.texture[no] = new MakeTexture(param.webgl.mainvisual.scene[no].src);
            this.texture[no].init(_this.w,_this.h,scene,no);
        }



        // setTimeout(()=>this.glitch(param.webgl.mainvisual.scene[no].type,no,"start"),2e3)


    }
    glitch(type,current,mode){

        let _target = type==="video" ? this.video[current].uniforms : this.texture[current].uniforms,
            _targetMesh = type==="video" ? this.videoMesh[current] : this.texture[current].mesh;

        if(mode==="start"){

            TweenMax.fromTo(_target.offsetX,0.1,
                {
                    value : 10,
                },
                {
                    value : 0,
                    ease : this.conf.ease,
                    delay:6,
                    repeat : -1,
                    repeatDelay:8,
                    onStart:()=>{
                        _target.offMask.value = false;
                        // _target.colorFilter.value = true;
                        // console.log("onStart");
                    },
                    onComplete:()=>{
                      // console.log("onComplete");
                    },
                    onRepeat:()=>{
                        // console.log("onRepeat");
                        _target.colorFilter.value = true;
                        setTimeout(()=>_target.colorFilter.value=false,1e2)

                    }
                }
            );
        }else{

            TweenMax.killTweensOf(_target.offsetX);
            _target.offMask.value = true;


        }

    }
    show(type,current){

        let _target = type==="video" ? this.video[current].uniforms : this.texture[current].uniforms,
            _targetMesh = type==="video" ? this.videoMesh[current] : this.texture[current].mesh,
            _maskTex =  type==="video" ? this.video[current].maskTex.x : this.texture[current].maskTex.x;

                // TweenMax.killChildTweensOf([_target,_targetMesh]);

        _target.tMask.value = _maskTex[Math.floor(util.random(0,2))];

        // if(current==3) _target.texture.value = this.texture[current].texOther[1];

        TweenMax.fromTo(_target.noiseMulti,this.conf.speed,{
                value : 0.6,
            },
            {
                value : 0,
                delay:0.2,
                ease : this.conf.ease
            }
        );
        TweenMax.set(_target.opacity,{value : 1});
        // TweenMax.fromTo(_target.opacity,this.conf.speed,
        //     {
        //         value : 0,
        //     },
        //     {
        //         value : 1,
        //         delay:0.2,
        //         ease : this.conf.ease
        //     }
        // );
        TweenMax.fromTo(_target.offsetX,this.conf.speed+0.5,
            {
                value : 100,
            },
            {
                value : 0,
                // delay:0.5,
                ease : this.conf.ease,
                // ease: SlowMo.ease.config(0.5, 0.4, false),
                onStart:()=>{
                    _target.offMask.value = false;
                    if(type==="video"){
                        if(!Useragnt.ie) this.video[current].video.video.play();
                    }
                    setTimeout(()=>_target.colorFilter.value = false,17e2)
                    setTimeout(()=>this.resize(this.w,this.h,type,current),2e2)
                },
                onComplete:()=>{
                    _target.offMask.value = true;
                    this.glitch(param.webgl.mainvisual.scene[current].type,current,"start")
                    _target.colorFilter.value = true;
                    setTimeout(()=>_target.colorFilter.value=false,1e2)
                }
            }
        );

        this.save.scale.show[current] = this.save.scale.show[current]==0 ? _targetMesh.scale.x : this.save.scale.out[current];


        // TweenMax.fromTo(_targetMesh.scale,this.conf.speed*0.8,
        //     {
        //         x : _targetMesh.scale.x*2,
        //     },
        //     {
        //         x : this.save.scale.show[current],
        //         delay:0.2,
        //         ease: Circ.easeOut,
        //         // onComplete:()=>{
        //         onStart:()=>{
        //             setTimeout(()=>this.resize(this.w,this.h,type,current),2e2)
        //         }
        //         // ease : this.conf.ease
        //     }
        // );

        // this.save.positionY.out[current] = this.save.positionY.out[current]==0 ? _targetMesh.scale.x : this.save.scale.out[current];

        TweenMax.fromTo(_targetMesh.position,this.conf.speed*0.8,
            {
                // x : this.w*8,
                x : this.w*4,
            },
            {
                x : 0,
                delay:0.2,
                ease: Circ.easeOut
                // ease : this.conf.ease
            }
        );


    }
    out(type,current){

        let _target = type==="video" ? this.video[current].uniforms : this.texture[current].uniforms,
            _targetMesh = type==="video" ? this.videoMesh[current] : this.texture[current].mesh,
            _maskTex =  type==="video" ? this.video[current].maskTex.x : this.texture[current].maskTex.x;


        _target.tMask.value = _maskTex[Math.floor(util.random(0,2))];

        this.save.scale.out[current] = _targetMesh.scale.x;
        TweenMax.killChildTweensOf(_target);
        TweenMax.killChildTweensOf(_targetMesh);
        _target.colorFilter.value = true;

        TweenMax.to(_target.noiseMulti,this.conf.speed,{
            value : 0.5,
            delay : 0.4,
            ease : this.conf.ease,
            onStart:()=>{
                _target.offMask.value = false;
                _target.colorFilter.value = true;
                setTimeout(()=>_target.colorFilter.value=false,1e2)
            },
        });
        // TweenMax.to(_target.opacity,this.conf.speed,{
        //     value : 0,
        //     delay : 0.4,
        //     ease : this.conf.ease
        // });
        TweenMax.to(_target.offsetX,this.conf.speed*0.7,{
            value : -200,
            ease : this.conf.ease,
            delay : 0.2,
            onStart:()=>{
                _target.colorFilter.value = false;
                // _target.offMask.value = false;
            },
            onComplete:()=>{
                _target.offMask.value = true;
                TweenMax.set(_target.opacity,{value : 0});
                this.glitch(param.webgl.mainvisual.scene[current].type,current,"stop")
                if(type==="video"){
                    if(!Useragnt.ie) this.video[current].video.video.pause();
                }
            }
        });
        // TweenMax.to(_targetMesh.scale,this.conf.speed*0.8,{
        //     x : _targetMesh.scale.x*3,
        //     ease : this.conf.ease,
        //     delay : 0.2,
        //     onComplete:()=>{
        //         if(type==="video"){
        //             if(!Useragnt.ie) this.video[current].video.video.pause();
        //         }
        //         TweenMax.set(_targetMesh.scale,{x:1})
        //     }
        // });
        TweenMax.to(_targetMesh.position,this.conf.speed,{
            x : -this.w*8,
            delay:0.3,
            ease : this.conf.ease
        });



    }
    showY(type,current){

        let _target = type==="video" ? this.video[current].uniforms : this.texture[current].uniforms,
            _targetMesh = type==="video" ? this.videoMesh[current] : this.texture[current].mesh;

        // TweenMax.killChildTweensOf([_target,_targetMesh]);

        TweenMax.fromTo(_target.noiseMulti,this.conf.speed,{
                value : 0.6,
            },
            {
                value : 0,
                delay:0.2,
                ease : this.conf.ease
            }
        );
        // TweenMax.fromTo(_target.opacity,this.conf.speed,
        //     {
        //         value : 0,
        //     },
        //     {
        //         value : 1,
        //         delay:0.2,
        //         ease : this.conf.ease
        //     }
        // );
        TweenMax.fromTo(_target.offsetY,this.conf.speed+0.5,
            {
                value : 100,
            },
            {
                value : 0,
                // delay:0.5,
                ease : this.conf.ease,
                // ease: SlowMo.ease.config(0.5, 0.4, false),
                onStart:()=>{
                    _target.offMask.value = false;
                    _target.offMaskY.value = false;
                    if(type==="video"){
                        if(!Useragnt.ie) this.video[current].video.video.play();
                    }
                },
                onComplete:()=>{
                    _target.offMask.value = true;
                    _target.offMaskY.value = true;
                    this.glitch(param.webgl.mainvisual.scene[current].type,current,"start")
                }
            }
        );

        this.save.scale.show[current] = this.save.scale.show[current]==0 ? _targetMesh.scale.y : this.save.scale.out[current];


        // TweenMax.fromTo(_targetMesh.scale,this.conf.speed*0.8,
        //     {
        //         y : _targetMesh.scale.y*2,
        //     },
        //     {
        //         y : this.save.scale.show[current],
        //         delay:0.2,
        //         ease: Circ.easeOut,
        //         // onComplete:()=>{
        //         onStart:()=>{
        //             this.resize(this.w,this.h,type,current)
        //         }
        //         // ease : this.conf.ease
        //     }
        // );

        TweenMax.fromTo(_targetMesh.position,this.conf.speed*0.8,
            {
                // x : this.w*8,
                y : this.h*4,
            },
            {
                y : this.save.positionY.out[current],
                delay:0.2,
                ease: Circ.easeOut,
                onStart:()=>{
                    this.resize(this.w,this.h,type,current)
                }
                // ease : this.conf.ease
            }
        );

    }

    outY(type,current){

        let _target = type==="video" ? this.video[current].uniforms : this.texture[current].uniforms,
            _targetMesh = type==="video" ? this.videoMesh[current] : this.texture[current].mesh;

        this.save.scale.out[current] = _targetMesh.scale.y;
        TweenMax.killChildTweensOf([_target,_targetMesh]);

        TweenMax.to(_target.noiseMulti,this.conf.speed*2,{
            value : 0.8,
            ease : this.conf.ease,
            onComplete:()=>{
                if(type==="video"){
                    if(!Useragnt.ie) this.video[current].video.video.pause();
                }
                TweenMax.set(_targetMesh.scale,{y:1})
            }
        });
        // TweenMax.to(_target.opacity,this.conf.speed*2,{
        //     value : 0,
        //     delay : 0.2,
        //     ease : this.conf.ease
        // });
        TweenMax.to(_target.offsetY,this.conf.speed*2*0.7,{
            value : -200,
            ease : this.conf.ease,
            onStart:()=>{
                _target.offMask.value = false;
                _target.offMaskY.value = false;
            },
            onComplete:()=>{
                _target.offMask.value = true;
                _target.offMaskY.value = true;
                this.glitch(param.webgl.mainvisual.scene[current].type,current,"stop")
            }
        });
        // TweenMax.to(_targetMesh.scale,this.conf.speed*2*0.8,{
        //     y : _targetMesh.scale.y*2,
        //     ease : this.conf.ease,
        //     onComplete:()=>{
        //         if(type==="video"){
        //             if(!Useragnt.ie) this.video[current].video.video.pause();
        //         }
        //         TweenMax.set(_targetMesh.scale,{y:1})
        //     }
        // });
        this.save.positionY.out[current] = _targetMesh.position.y;
        TweenMax.to(_targetMesh.position,this.conf.speed,{
            y : this.h*8,
            delay:0.1,
            ease : this.conf.ease
        });



    }

    productChange(texNo){

        if(texNo!=0){
            this.texture[3].uniforms["texture"] = {value:this.texture[3].texOther[texNo] }
        }else{
            this.texture[3].uniforms["texture"] = {value:this.texture[3].tex }
        }

    }

    render(mouse,time,fpsRate,type,no){

        if(type=="video"){
            if(this.video[no]==undefined) return;
            if(time%2!==0) this.video[no].uniforms.time.value +=1;
            if(Useragnt.mobile){
                this.video[no].video.video.currentTime += 0.02*fpsRate;
                if(this.video[no].video.video.currentTime>=this.video[no].video.video.duration) this.video[no].video.video.currentTime = 0;
                // this.video[no].videoTexture.needsUpdate = true;
            }
        }else{
            if(this.texture[no]==undefined||time%2==0) return;
            this.texture[no].uniforms.time.value +=1;
        }

    }
    resize(w,h,type,no){
        this.w = w;
        this.h = h;

        if(type=="video"){
            if(this.video[no]==undefined) return;

            /* 動画を画面サイズに合わせる */
            if(!Useragnt.ie){
                let movW = w;
                let movH = this.video[no].video.video.videoHeight * (movW /this.video[no].video.video.videoWidth);
                if (movH < h){
                    movH = h;
                }

                movW = this.video[no].video.video.videoWidth * (movH / this.video[no].video.video.videoHeight);

                if(Useragnt.mobile){
                    this.videoMesh[no].position.set(0,-movH*1.76*0.1,0);
                    this.videoMesh[no].scale.set(movW*1.1, movH*1.76*1.1, 1);
                    // this.videoMesh[no].position.set(-movW*0.563*0.1,0,0);
                    // this.videoMesh[no].scale.set(movW*0.563*1.1, movH*1.1, 1);
                }else{
                    this.videoMesh[no].scale.set(movW, movH, 1);
                }
            }else{

                this.videoMesh[no].scale.set(this.w, this.h, 1);
            }
        }else{

            if(this.texture[no]===undefined) return;
            if(this.texture[no].mesh===undefined) return;
            let texW = w;
            let texH = this.texture[no].tex.image.height * (texW /this.texture[no].tex.image.width);
            if (texH < h){
                texH = h;
            }

            texW = this.texture[no].tex.image.width * (texH / this.texture[no].tex.image.height);

            // console.log(no,this.texture[no].uniforms)

            this.texture[no].mesh.scale.set(texW, texH, 1);
            // this.texture[no].resize(texW,texH);
        }


    }

}